import Particles from "../App/Components/Particles";
import DailyDevCard from "./Components/DailyDevCard";
import EducationTimeLine from "./Components/EducationTimeLine";
import ExperienceTimeLine from "./Components/ExperienceTimeLine";
import FooterSection from "./Components/FooterSection";
import GitContributions from "./Components/GitContributions";
import HeroSection from "./Components/HeroSection";
import AmbientBg from "./Components/layout/AmbientBg";
import OpacityFilterTop from "./Components/layout/OpacityFilterTop";
import MobileNavBar from "./Components/MobileNavBar";
import NavBar from "./Components/NavBar";
import SkillsArea from "./Components/SkillsArea";
import SectionTitle from "./Components/Title/SectionTitle";

const HomePage = () => {
    return (
        <div className="overflow-clip relative">
            <div
                style={{
                    minWidth: "100%",
                    height: "100vh",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 0,
                }}
            >
                <div className="relative h-full w-full">
                    <Particles
                        particleColors={["#ffffff", "#ffffff"]}
                        particleCount={120}
                        particleSpread={10}
                        speed={0.2}
                        particleBaseSize={200}
                        moveParticlesOnHover={false}
                        alphaParticles={true}
                        disableRotation={false}
                    />
                </div>
            </div>
            <div className="sticky top-3 z-[9999]">
                <NavBar />
                <MobileNavBar />
            </div>

            {/* layout of main ui */}
            <div className="pb-5 px-5 md:px-10 xl:px-16 2xl:px-20 z-10 flex flex-col items-center justify-center max-w-[1100px] mx-auto">
                <OpacityFilterTop />
                <AmbientBg
                    colorClass="bg-[#0f84ca]"
                    positionClass="translate-x-[-120%] translate-y-[-350%]"
                />
                <div id="about" className="pt-[150px] sm:pt-[190px]">
                    <HeroSection />
                </div>

                <div id="skills" className="w-full max-w-[100vw] pt-10">
                    <SkillsArea />
                </div>

                <div id="experience" className="pt-10 w-full">
                    <SectionTitle title="Experience" />
                    <ExperienceTimeLine />
                </div>

                <div id="education" className="pt-10 w-full">
                    <AmbientBg
                        colorClass="bg-pink-300"
                        positionClass="translate-x-[10%] translate-y-[-10%] sm:translate-x-[100%] sm:translate-y-[60%]"
                    />
                    <SectionTitle title="Education" />
                    <EducationTimeLine />
                </div>

                <div id="contributions" className="w-full z-50">
                    <AmbientBg
                        colorClass="bg-[#ae99d2]"
                        positionClass="translate-x-[-20%] translate-y-[-10%] sm:translate-y-[25%] z-[-1111]"
                    />
                    <div className="z-[9999]">
                        <div className="py-10">
                            <DailyDevCard />
                        </div>
                        <SectionTitle title="Github Contributions" />
                        <GitContributions />
                    </div>
                </div>

                <FooterSection />
            </div>
        </div>
    );
};

export default HomePage;
